import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";

function App() {
  const [darkMode, setDarkMode] = useState(false);

  const isLoggedIn = !!localStorage.getItem("token");

  const logout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  return (
    <div style={{ background: darkMode ? "#121212" : "#f4f6f8", minHeight: "100vh" }}>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <Login
                darkMode={darkMode}
                setDarkMode={setDarkMode}
                isLoggedIn={isLoggedIn}
                logout={logout}
              />
            }
          />

          <Route
            path="/register"
            element={
              <Register
                darkMode={darkMode}
                setDarkMode={setDarkMode}
                isLoggedIn={false}
              />
            }
          />

          <Route
            path="/dashboard"
            element={
              <Dashboard
                darkMode={darkMode}
                setDarkMode={setDarkMode}
                isLoggedIn={isLoggedIn}
                logout={logout}
              />
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;